import { RequestServerClass } from '../../util/request';
import publishObjectPath from '@/util/configRegistry';
import { changePostParam } from '@/util/changePostParam'; // post请求体转换方法

const serverUrl = publishObjectPath.serverUrl;

export class YunnanDataViewServer {
  public rSerivce: any;

  constructor(opt: any, axiosFilterFn?: any) {
    this.rSerivce = new RequestServerClass(opt);
    axiosFilterFn.call(this, this.rSerivce.serverObj);
  }

  // 检查
  public getSecurityCheck() {
    const url = serverUrl + '/api/yunnan/cockpit-statistics/v1/security-check';
    return this.rSerivce.serverObj.get(url);
  }

  // 隐患列表
  public getSecurityCheckStatisticsNumberList(opts: object) {
    const url = serverUrl + '/api/yunnan/cockpit-statistics/v1/security-check/statistics-number-list';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 履责列表
  public getProfessionStatisticsNumberList(opts: object) {
    const url = serverUrl + '/api/yunnan/cockpit-statistics/v1/profession/statistics-number-list';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 检查二级页面
  public getSecurityCheckSecondPage(opts: object) {
    const url = serverUrl + '/api/yunnan/cockpit-statistics/v1/security-check/second-page';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 履职
  public getProfessionStaffRate(opts: any) {
    const url = serverUrl + '/api/yunnan/cockpit-statistics/v1/profession/staff-rate';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 履职
  public getProfessionBlock1Detail(opts: any) {
    const url = serverUrl + '/api/yunnan/cockpit-statistics/v1/profession/block1/detail';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 履职
  public getProfessionListDetail(opts: any) {
    const url = serverUrl + '/api/yunnan/cockpit-statistics/v1/profession/list/detail';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 履职部门维度
  public getProfessionListDeptDetail(opts: any) {
    const url = serverUrl + '/api/yunnan/cockpit-statistics/v1/profession/staff-rate';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 隐患
  public getHazard(opts: any) {
    const url = serverUrl + '/api/yunnan/cockpit-statistics/v1/hazard';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 隐患 点巡检列表
  public getPointPatrolList(page: any, opts: any) {
    const url = serverUrl + '/api/yunnan/cockpit-statistics/v2/point/patrol/list' + changePostParam(page);
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 隐患 点巡检列表
  public getDevicePatrolList(page: any, opts: any) {
    const url = serverUrl + '/api/yunnan/cockpit-statistics/v2/device/patrol/list' + changePostParam(page);
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 排查
  public getPatrolAndDeviceStatistics(opts: any) {
    const url = serverUrl + '/api/yunnan/cockpit-statistics/v2/patrol-and-device/statistics';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 隐患月度统计
  public getHazardBlockDetail(opts: any) {
    const url = serverUrl + '/api/yunnan/cockpit-statistics/v1/hazard/block1/detail';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 查询整体区域绘制地图视频点位
  public getMapCamera() {
    const url = serverUrl + '/api/yunnan/external/video-point-info/list?isShowMap=true';
    return this.rSerivce.serverObj.get(url);
  }

  // 根据ID查询设备报警记录
  public getSelectLastTen(opts: any) {
    const url = serverUrl + '/api/yunnan/alarmInfo/selectLastTen';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 根据ID查询设备曲线图
  public getChartData(opts: any) {
    const url = serverUrl + '/api/yunnan/alarmInfo/getBigMapData';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 根据ID查询设备基础信息
  public getBaseData(id: any) {
    const url = serverUrl + '/api/yunnan/alarmInfo/' + id;
    return this.rSerivce.serverObj.get(url);
  }

  // 获取检查统计 日周月数字 驾驶舱
  public getCheckCollect(opts: object) {
    const url = serverUrl + '/api/yunnan/cockpit-statistics/v2/check/collect';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 获取检查统计 日周月数字 驾驶舱
  public getCheckDayDistributed(opts: object) {
    const url = serverUrl + '/api/yunnan/cockpit-statistics/v2/check/day/distributed';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 获取危险作业 日周月数字 驾驶舱
  public getWorkTicketCollect(opts: object) {
    const url = serverUrl + '/api/yunnan/cockpit-statistics/v2/workTicket/collect';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 获取危险作业 日周月数字 驾驶舱
  public getWorkTicketDayDistributed(opts: object) {
    const url = serverUrl + '/api/yunnan/cockpit-statistics/v2/workTicket/day/distributed';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 获取企业定位信息
  public getCompanyAll() {
    const url = serverUrl + '/api/yunnan/company/all';
    return this.rSerivce.serverObj.get(url);
  }
}
